import { Close } from '@mui/icons-material';
import { CircularProgress, IconButton, InputAdornment } from '@mui/material';
import React from 'react';
import { Restaurant } from 'types/restaurant';

interface RestaurantAutocompleteAdornmentProps {
  selected: Restaurant | null;
  loading: boolean;
  clearSelected(): void;
}

const RestaurantAutocompleteAdornment: React.FC<RestaurantAutocompleteAdornmentProps> = ({
  selected,
  loading,
  clearSelected,
}) => {
  return (
    <InputAdornment position="end">
      {loading ? (
        <CircularProgress color="primary" size={24} />
      ) : (
        selected && (
          <IconButton onClick={clearSelected}>
            <Close />
          </IconButton>
        )
      )}
    </InputAdornment>
  );
};

export default RestaurantAutocompleteAdornment;
